<script setup>

import { inject } from 'vue';
import ListeDimensions from './listeDimensions/ListeDimensions.vue';
import DetailDimension from './detailDimension/DetailDimension.vue';

const { dimensions } = defineProps({
  dimensions: Array
});

const selectionSchema = inject('selectionSchema');

</script>

<template>
	<div class="panel-lateral contenu-onglet-schema">
		<ListeDimensions :dimensions="dimensions" />
		<DetailDimension v-if="selectionSchema.dimension" :dimension="selectionSchema.dimension" />
	</div>
</template>

<style scoped>
</style>